export const SET_GETREGISTRATIONSTEPS = "SET_GETREGISTRATIONSTEPS";
export const SET_SETREGISTRATIONSTEPS = "SET_SETREGISTRATIONSTEPS";
export const SET_GETCENTERS = "SET_GETCENTERS";